module.exports = __webpack_public_path__ + "assets/img/14_1600.4b81d773.jpg";